import {
    CustomAttributeConfigurationQueryParam,
    ICustomAttributeConfiguration,
    ISaveCustomAttributeConfiguration,
    supportApi,
} from '../../shared';
import { NewBaseClient } from '../../shared/clients/new-base.client';

class CustomAttributeConfigurationClient extends NewBaseClient<
    ISaveCustomAttributeConfiguration,
    ICustomAttributeConfiguration,
    CustomAttributeConfigurationQueryParam
> {
    constructor() {
        super(supportApi, '/custom-attribute-configurations');
    }
}

export const customAttributeConfigurationClient = new CustomAttributeConfigurationClient();
